import script from "./EducationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationPage.vue?vue&type=script&setup=true&lang=js"

import "./EducationPage.vue?vue&type=style&index=0&id=53109cfa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53109cfa"]])

export default __exports__